import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';
import _ from "lodash";

const validateDepartmentsWeights = (departments) => {
  const errors = [];
  const reducedWeighOld = _.reduce(departments, (sum, current) => { return sum + current.weightOld}, 0);
  const reducedWeightNewComing = _.reduce(departments, (sum, current) => { return sum + current.weightNewComing}, 0);
  const reducedWeightNew = _.reduce(departments, (sum, current) => { return sum + current.weightNew}, 0);
  if(reducedWeighOld !== 100 && reducedWeighOld) {
    errors.push(`Η εξάμηνη βαρύτητα δεν αθροίζεται στο 100 (Σύνολο: ${reducedWeighOld})`)
  }
  if(reducedWeightNewComing !== 100 && reducedWeightNewComing) {
    errors.push(`Η βαρύτητα των υφιστάμενων καταστημάτων δεν αθροίζεται στο 100 (Σύνολο: ${reducedWeightNewComing})`)
  }
  if(reducedWeightNew !== 100 && reducedWeightNew) {
    errors.push(`Η βαρύτητα των νέων καταστημάτων δεν αθροίζεται στο 100 (Σύνολο: ${reducedWeightNew})`)
  }
  return errors;
};

const INITIAL_STATE = fromJS({
  departments: fromJS([]),
  fetching: false,
  errors: fromJS([])
});

function getDepartments(state, action){
  return state
    .set('fetching', true);
}

function getDepartmentsSuccess(state, action) {
  const errors = validateDepartmentsWeights(action.payload.body);
  return state
    .set('departments', fromJS(action.payload.body))
    .set('fetching', false)
    .set('errors', fromJS(errors));
}

function getDepartmentsFailed(state, action) {
  return state
    .set('fetching', false);
}

function resetState(state, action) {
  return INITIAL_STATE;
}

function changeDepartmentsState(state, action) {
  return state
    .set(action.payload.key, fromJS(action.payload.value))
}

function getDepartmentsWithFilters(state, action) {
  return state
    .set('fetching', true);
}

function getDepartmentsWithFiltersSuccess(state, action) {
  return state
    .set('departments', fromJS(action.payload.body))
    .set('fetching', false);
}

function getDepartmentsWithFiltersFailed(state, action) {
  return state
    .set('fetching', false);
}

export const departments = createReducer(INITIAL_STATE, {
  [ActionTypes.GET_DEPARTMENTS]: getDepartments,
  [ActionTypes.GET_DEPARTMENTS_SUCCESS]: getDepartmentsSuccess,
  [ActionTypes.GET_DEPARTMENTS_FAILED]: getDepartmentsFailed,
  [ActionTypes.LOG_OUT]: resetState,
  [ActionTypes.CHANGE_DEPARTMENTS_STATE]: changeDepartmentsState,
  [ActionTypes.GET_DEPARTMENTS_WITH_FILTERS]: getDepartmentsWithFilters,
  [ActionTypes.GET_DEPARTMENTS_WITH_FILTERS_SUCCESS]: getDepartmentsWithFiltersSuccess,
  [ActionTypes.GET_DEPARTMENTS_WITH_FILTERS_FAILED]: getDepartmentsWithFiltersFailed,
});



// WEBPACK FOOTER //
// ./src/reducers/departments.js